module.exports = __webpack_public_path__ + "media/packs/images/markers/sea-6741778f9f952d23f48b26bc76edc03e.svg";